import { useState, useEffect }from 'react'
import {Table, Button, Modal, Space} from 'antd';
import {PlusOutlined} from '@ant-design/icons'
import resumeData from './Sections/DefaultResume.json';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import { SERVER_ROUTE } from '../Config.js'
import { useDispatch } from 'react-redux';
import { addNotification } from '../../_actions/notification_actions';

function MyResumes(props) {
  // const [resumeDefault, setResumeDefault] = useState(resumeData);
  const [resumeList, setResumeList] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [jobDescription, setJobDescription] = useState("");
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setResumeDefault(resumeData);
  // }, []);

    const showModal = () => {
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
    };

  const getFormattedDate = (value) => {
    if (!value) return "";
  
    const date = new Date(value);
    const day = date.getDate();
    const monthName = date.toLocaleString("en-US", { month: "short" }); // Gets "Jan", "Feb", etc.
    const year = date.getFullYear();
  
    return `${monthName} ${day}, ${year}`;
  };
  const columns = [
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        render: (text, record) => (
          <button style={{border: 'none', background: 'none', color: '#1890ff', cursor: 'pointer'}} onClick={() => {
            props.history.push({
              pathname: "/body",
              state: { resumeId: record.key, userId: props.user.userData._id } //
            });
          }}>
            {text}
          </button>
        )
      },
      {
        title: 'Last Modified',
        dataIndex: 'last_modified',
        key: 'last_modified',
        render: (text) => <p>{getFormattedDate(text)}</p>,
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <Button type="primary" danger onClick={() => handleDelete(record.key)}>
            Delete
          </Button>
        ),
      },
  ];

  // const addResume = async (resume) => {

  // }

  const addResume = async (resume) => {
    const variable = {
      resume: resume,
      userId: props.user.userData._id,
    }
    const responese = await Axios.post(`${SERVER_ROUTE}/api/resume/uploadResume`, variable, { withCredentials: true });
    if (responese.data.success) {
      return responese.data.id;
    } else {
      return null;
    }
  }

  const handleAddNew = async (resumeData) => {
    const resumeId = await addResume(resumeData);
    if (resumeId) {
      props.history.push({
        pathname: "/body",
        state: { resumeId: resumeId, userId: props.user.userData._id } //
      });
      return true;
    } else {
      return false;
    }
  }

  const handleDelete = (resumeId) => {
    Axios.post(`${SERVER_ROUTE}/api/resume/deleteResume`, { resumeId: resumeId, userId: props.user.userData._id }, { withCredentials: true })
    .then(response =>{
      if(response.data.success){
        setResumeList(resumeList.filter((resume) => resume.key !== resumeId));
      }else{
        alert('Failed to delete Resume');
      }
    })
  }

  const compareByDateDesc = (a, b) => {
    return new Date(b.last_modified) - new Date(a.last_modified);
  };

  const pollForResume = async (requestId) => {
  const intervalId = setInterval(() => {
    Axios.get(`${SERVER_ROUTE}/api/generateResume/resume-status/${requestId}`)
      .then(async (res) => {
        if (res.data.status === "completed") {
          const resumeId = await addResume(res.data.resume);
          console.log("Added Resume ID:", resumeId);
          if (!resumeId) {
            alert("Failed to add the generated resume. Please try again.");
            clearInterval(intervalId);
            return;
          }
          dispatch(addNotification({
            type: "success",
            message: "✅ Resume generated successfully!",
            resumeId: resumeId, // This can be used to open the resume later
            isRead: false,
          }));
          clearInterval(intervalId);
        } else if (res.data.status === "failed") {
          dispatch(addNotification("❌ Resume generation failed. Please try again."));
          alert("Resume generation failed.");
          clearInterval(intervalId);
        }
      })
      .catch(console.error);
  }, 3000);
};
  // const pollForResume = async (requestId) => {
  // const intervalId = setInterval(() => {
  //   Axios.get(`${SERVER_ROUTE}/api/generateResume/resume-status/${requestId}`)
  //     .then(async (res) => {
  //       if (res.data.status === "completed") {
  //         // console.log("Generated Resume:", res.data.resume);
  //         const resumeId = await addResume(res.data.resume);
  //         console.log("Added Resume ID:", resumeId);
  //         if(!resumeId) {
  //           alert("Failed to add the generated resume. Please try again.");
  //           return;
  //         }
  //         dispatch(addNotification({
  //           type: "success",
  //           message: "✅ Resume generated successfully!",
  //           resumeId: resumeId,
  //         }));
  //         clearInterval(intervalId); // stop polling
  //       } else if (res.data.status === "failed") {
  //         dispatch(addNotification("❌ Resume generation failed. Please try again."));
  //         alert("Resume generation failed.");
  //         clearInterval(intervalId);
  //       }
  //     })
  //     .catch(console.error);
  // }, 3000); // poll every 3 seconds
  // };

  const CreateWithAI = () => {
    setConfirmLoading(true);
    const variable = {
      userId: props.user.userData._id,
      jobDescription: jobDescription,
    }

    Axios.post(`${SERVER_ROUTE}/api/generateResume/generate-resume`, variable, { withCredentials: true })
    .then(response =>{
      if(response.data.success){
        pollForResume(response.data.requestId);
      }else{
        alert('Failed to create Resume');
      }
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setConfirmLoading(false);
      setOpen(false);
      setJobDescription("");
    }
    )
  }

    
  useEffect(() =>{
    if(props.user && props.user.userData){
      Axios.get(`${SERVER_ROUTE}/api/users/getResumeList?userId=${props.user.userData._id}`, { withCredentials: true })
      .then(response =>{
        let myResumes = response.data.resumes.map((ele, index) =>{
            return {
              key: ele.id,
              title: ele.title,
              last_modified: ele.date
            }
          })
          const sortedResumes = myResumes.sort(compareByDateDesc);
          setResumeList(sortedResumes);
      })
    }
  },[props.user])
  return (
  <div style={{height: '92vh', paddingTop: '1rem', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    marginX: '0px',
    backgroundImage: 'url("https://www.transparenttextures.com/patterns/45-degree-fabric-dark.png")'}}>
    <div style={{ 
                display: 'flex', flexDirection: 'column',
                margin: '1rem',
                gap: '1rem',  
                minHeight: '80dvh',
                backgroundColor:'#fff',  overflow:'auto',
                padding: '0.5rem', borderRadius: '0.25rem'}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: '1rem'}}>
          <Button onClick = {() => handleAddNew(resumeData)} type="primary" icon={<PlusOutlined />} size='large' style={{maxWidth: '100px', marginBottom: '0.25rem'}}>
          New 
          </Button>
          <Button onClick={showModal} type="primary" size='large' style={{maxWidth: '200px', marginBottom: '0.25rem'}}>
            Create with AI
          </Button>
        </div>
        <Table 
        pagination={{ pageSize: 6 }}
        dataSource={resumeList} columns={columns} 
        locale={{
          emptyText: (
            <div style={{ textAlign: "center" }}>
                Create Your First Resume
            </div>
          ),
        }}
        />
        <Modal
          title="Create New Resume"
          open={open}
          onOk={CreateWithAI}
          onCancel={handleCancel}
          okText="Create"
          cancelText="Cancel"
          confirmLoading={confirmLoading}
          maskClosable={false}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
          >
          <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <textarea
              placeholder="Enter Job Description"
              rows={4}
              value={jobDescription}
              onChange={(e) => setJobDescription(e.target.value)}
              style={{ width: '100%', height: '200px', resize: 'none', padding: '0.5rem', borderRadius: '0.25rem', border: '1px solid #d9d9d9'}}
            />
          </Space>
        </Modal>
    </div>
  </div>
  )
}

export default withRouter(MyResumes)
